import { IPublicAccountCategoryResponse, IPublicAccountSubcategoryResponse } from '../../../../model/apm/public-account/response/public-account-category-response';

// Subcategorias da categoria escolhida; sem categoria, todas (com o nome da categoria para diferenciar)
export function subcategoryOptions(categories: IPublicAccountCategoryResponse[], categoryId?: number): (IPublicAccountSubcategoryResponse & { label: string })[] {
    return categories
        .filter((c) => !categoryId || c.id === categoryId)
        .flatMap((c) => (c.subcategories || []).map((s) => ({
            ...s,
            label: categoryId ? s.description || '' : `${c.description} › ${s.description}`,
        })));
}

export function categoryIdOfSubcategory(categories: IPublicAccountCategoryResponse[], subcategoryId?: number): number | undefined {
    if (!subcategoryId) return undefined;
    return categories.find((c) => (c.subcategories || []).some((s) => s.id === subcategoryId))?.id;
}
